/**
 * The first name to greet a signed-in user by. Prefers their real name — the
 * saved profile first name, else the first token of the display name — and only
 * falls back to a title-cased email local-part when no name is on file. Returns
 * `null` when nothing usable is available, so each caller can pick its own
 * placeholder (e.g. "there" vs. omitting the name entirely).
 *
 * Shared by the dashboard Home greeting and the global Header fallback so the
 * two surfaces always resolve the name the same way.
 */
export function greetingFirstName(input: {
  firstName?: string | null;
  displayName?: string | null;
  email?: string | null;
}): string | null {
  const fromProfile = input.firstName?.trim() || input.displayName?.trim().split(/\s+/)[0] || null;
  if (fromProfile) return fromProfile;

  const local = input.email?.split('@')[0]?.split(/[._-]/)[0] ?? '';
  return local ? local.replace(/^./, (letter) => letter.toUpperCase()) : null;
}
